// extracted by mini-css-extract-plugin
export default {"subheader":"style_subheader__C-NRm","page":"style_page__kCaba"};